import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyable",on:{"mouseover":function($event){_vm.hover = true},"mouseleave":function($event){_vm.hover = false}}},[_c('div',{staticClass:"copyarea"},[_vm._t("default")],2),_c(VBtn,{staticClass:"copy-btn",style:(_vm.style),attrs:{"x-small":"","icon":""},on:{"click":_vm.copy}},[_c(VIcon,{staticStyle:{"opacity":".7"},attrs:{"size":"12"}},[_vm._v("mdi-content-copy")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }